import { render, staticRenderFns } from "./TplConfig.vue?vue&type=template&id=394242a1&scoped=true&"
import script from "./TplConfig.vue?vue&type=script&lang=js&"
export * from "./TplConfig.vue?vue&type=script&lang=js&"
import style0 from "./TplConfig.vue?vue&type=style&index=0&id=394242a1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394242a1",
  null
  
)

export default component.exports